/** @jsxRuntime classic */
/** @jsx jsx */
import {
  Alert,
  AlertDescription,
  Box,
  Button,
  Flex,
  Text,
} from '@chakra-ui/react';
import { css, jsx } from '@emotion/react';
import axios from 'axios';
import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { selectShow, ShowNotification } from '../redux/showSlice';
import Footer from './layout/Footer';
import Header from './layout/HeaderB';
import './Styles.css';

const Search = props => {
  const [searchName, setName] = useState('');
  const [searchZip, setZip] = useState('');
  const [searchCuisine, setCuisine] = useState('');
  const [restaurants, setRestaurants] = useState([]);
  const showView = useSelector(selectShow);
  const dispatch = useDispatch();
  const options = [
    { value: 'African', label: 'African' },
    { value: 'American', label: 'American' },
    { value: 'Bakery', label: 'Bakery' },
    { value: 'Chicken', label: 'Chicken' },
    { value: 'Continental', label: 'Continental' },
    { value: 'Delicatessen', label: 'Delicatessen' },
    { value: 'Donuts', label: 'Donuts' },
    { value: 'French', label: 'French' },
    { value: 'Greek', label: 'Greek' },
    { value: 'Hamburgers', label: 'Hamburgers' },
    { value: 'Italian', label: 'Italian' },
    { value: 'Irish', label: 'Irish' },
    { value: 'Jewish/Kosher', label: 'Jewish/Kosher' },
    { value: 'Mexican', label: 'Mexican' },
    { value: 'Pizza', label: 'Pizza' },
    { value: 'Polish', label: 'Polish' },
    { value: 'Scandinavian', label: 'Scandinavian' },
    { value: 'Steak', label: 'Steak' },
    { value: 'Turkish', label: 'Turkish' },
  ];
  const styles = {
    container: base => ({
      ...base,
      width: '175px',
      padding: '10px',
      borderRadius: '10px',
      marginLeft: '10px',
    }),
  };

  const handleSearchInputChanges_Name = e => {
    setName(e.target.value);
  };

  const resetInputField_Name = () => {
    setName('');
  };

  const callSearchFunction_Name = e => {
    e.preventDefault();
    if (!searchName) {
      alert('Give restaurant name');
      return;
    }
    const notify = () => toast.loading('Loading...', { icon: '⌛' });
    notify();
    axios
      .post('https://mern-stack-restaurants-app.herokuapp.com/search/name', {
        searchName,
      })
      .then(res => {
        setRestaurants(res.data);
        if (restaurants.length === 0) dispatch(ShowNotification());
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        toast.dismiss();
      });
    resetInputField_Name();
  };

  const handleSearchInputChanges_Zip = e => {
    setZip(e.target.value);
  };

  const resetInputField_Zip = () => {
    setZip('');
  };

  const callSearchFunction_Zip = e => {
    e.preventDefault();
    if (!searchZip) {
      alert('Give restaurant zip code');
      return;
    }
    const notify = () => toast.loading('Loading...', { icon: '⌛' });
    notify();
    axios
      .post('https://mern-stack-restaurants-app.herokuapp.com/search/zipcode', {
        searchZip,
      })
      .then(res => {
        setRestaurants(res.data);
        if (restaurants.length === 0) dispatch(ShowNotification());
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        toast.dismiss();
      });
    resetInputField_Zip();
  };

  const handleSearchInputChanges_Cuisine = e => {
    setCuisine(e.value);
  };

  const callSearchFunction_Cuisine = e => {
    e.preventDefault();
    if (!searchCuisine) {
      alert('Give cuisine');
      return;
    }
    const notify = () => toast.loading('Loading...', { icon: '⌛' });
    notify();
    axios
      .post('https://mern-stack-restaurants-app.herokuapp.com/search/cuisine', {
        searchCuisine,
      })
      .then(res => {
        setRestaurants(res.data);
        if (restaurants.length === 0) dispatch(ShowNotification());
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        toast.dismiss();
      });
  };

  return (
    <React.Fragment>
      <Box
        css={{
          minHeight: 'calc(100vh - 80px)',
          marginBottom: '-5px',
        }}
      >
        <Header />
        <Toaster />
        <Flex direction="row" wrap="wrap" justify="center">
          <form
            css={css`
              border: 0;
              @media (max-width: 350px) {
                font-size: 13px;
              }
            `}
          >
            <input
              value={searchName}
              onChange={handleSearchInputChanges_Name}
              type="text"
              placeholder="Search by name"
              css={{
                padding: '10px 5px',
              }}
            />
            <Button onClick={callSearchFunction_Name} ml={5} bg="#f9bf3b" p={5}>
              SEARCH
            </Button>
          </form>
          <form
            css={css`
              border: 0;
              marginleft: 20px;
              @media (max-width: 350px) {
                font-size: 13px;
              }
            `}
          >
            <input
              value={searchZip}
              onChange={handleSearchInputChanges_Zip}
              type="text"
              placeholder="Search by zip"
              css={{
                marginLeft: '20px',
                padding: '10px 5px',
              }}
            />
            <Button onClick={callSearchFunction_Zip} ml={5} bg="#f9bf3b" p={5}>
              SEARCH
            </Button>
          </form>
          <Select
            defaultValue={{
              value: 'African',
              label: 'African',
            }}
            onChange={handleSearchInputChanges_Cuisine}
            options={options}
            styles={styles}
          />
          <Button
            onClick={callSearchFunction_Cuisine}
            mt={2}
            ml={3}
            bg="#f9bf3b"
            p={5}
          >
            SEARCH
          </Button>
        </Flex>
        <Flex direction="row" wrap="wrap" justify="center" mt={8}>
          {restaurants.length > 0 ? (
            restaurants.map((restaurant, index) => {
              const GoogleMapsSearch = `${restaurant.address.building} ${restaurant.address.street}, ${restaurant.address.zipcode}`;
              return (
                <>
                  <Flex
                    key={index}
                    direction="column"
                    align="center"
                    justify="start"
                    textAlign="center"
                    w="300px"
                    border="2px solid #000"
                    mb={10}
                    mx={5}
                    pb={5}
                    pt={5}
                    bg="#e8ecf1"
                    overflow="hidden"
                  >
                    <Box>
                      <Text
                        fontSize="lg"
                        fontWeight="700"
                        as="u"
                        color="#ff0000"
                      >
                        {restaurant.name}
                      </Text>
                      <Text fontSize="lg" color="#000" mt={2}>
                        Cuisine:
                      </Text>
                      <Text fontSize="lg" color="#000">
                        {restaurant.cuisine}
                      </Text>
                      <Text fontSize="lg" color="#000" mt={2}>
                        Address:
                      </Text>
                      <Text fontSize="lg" color="#000">
                        {restaurant.address.street},{restaurant.address.zipcode}
                      </Text>
                      <Box mb={3}>
                        <Flex
                          mt={3}
                          direction="row"
                          wrap="wrap"
                          justify="center"
                        >
                          <Button
                            bg="#f9bf3b"
                            _hover={{
                              background: '#ff0000',
                              color: '#fff',
                            }}
                          >
                            <Link to={`/write/${restaurant._id}`}>
                              Write Review
                            </Link>
                          </Button>
                          <Button
                            ml={2}
                            bg="#f9bf3b"
                            _hover={{
                              background: '#ff0000',
                              color: '#fff',
                            }}
                          >
                            <Link to={`/view/${restaurant._id}`}>
                              View Reviews
                            </Link>
                          </Button>
                        </Flex>
                      </Box>
                      <Button
                        bg="#f9bf3b"
                        _hover={{
                          background: '#ff0000',
                          color: '#fff',
                        }}
                      >
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={
                            'https://www.google.com/maps/place/' +
                            GoogleMapsSearch
                          }
                        >
                          View Map
                        </a>
                      </Button>
                    </Box>
                  </Flex>
                </>
              );
            })
          ) : showView === 'Show' ? (
            <Alert bg="#f9bf3b" color="#000" w={200}>
              <AlertDescription px={1} py={1}>
                No restaurants found
              </AlertDescription>
            </Alert>
          ) : null}
        </Flex>
      </Box>
      <Footer />
    </React.Fragment>
  );
};

export default Search;
